import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {Flow} from "../../../../FlowState.js";
import {LoadingSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {Messages} from "../../../../../Messages";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {INLINE_DONATION_URLS, INLINE_EDIT_DONATION_URLS, PAYMENT_DETAILS_PANEL_URL} from "../../../../PanelConstants";
import {PaymentMethodAcceptOrChange} from "../../payment-method/components/PaymentMethodAcceptOrChange.jsx";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore";
import {DonationStore} from "../../../../../../client/state/DonationStore";
import {BasePanelPage, BasePanelPageStyle} from "../../../../PanelPage";
import {styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {DonateComponent} from "../components/DonateComponent";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {autoredraw} from "../../../../../../stem-core/src/decorators/AutoRedraw";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {Controller} from "../../../../Controller";


export class EditDonationComponent extends DonateComponent {
    updateDonation() {
        Flow.donation.updateDonation(Flow.donation.getTotalAmount());
    }
}

class EditDonationPanelStyle extends BasePanelPageStyle {
    @styleRule
    description = {
        display: "inline",
    };

    @styleRuleInherit
    body = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    }
}

@autoredraw(PaymentMethodStore, DonationStore)
@registerStyle(EditDonationPanelStyle)
export class EditDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editDonationInlineTitle,
        };
    }

    isButtonDisabled() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        return !(Flow.donation.isValid()
            && (Flow.donation.donationAmount !== donation.computeAmount()
                || Flow.donation.payDonationFeeCheckboxChecked !== donation.isDonationFeePaid()
                || donation.getPaymentMethod() !== Controller.paymentMethod.selectedPaymentMethod));
    }

    updateDonation() {
        LoadingSpinner.show();
        this.editDonationComponent.updateDonation();
    }

    render() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        Controller.paymentMethod.initialPaymentMethod = Controller.paymentMethod.selectedPaymentMethod;

        return [
            <div>
                <MessageElement
                    className={styleSheet.description}
                    message={Messages.donatePageRecurringDonationMessage(donation.formatPrice())}
                />
                <Link
                    value={Messages.here}
                    style={{display: "inline-block"}}
                    href={INLINE_EDIT_DONATION_URLS.cancel}
                />.
            </div>,
            !iFrameMerchantService.isCDSPaymentMethod() && <PaymentMethodAcceptOrChange style={{marginTop: 12, marginBottom: 12}} />,
            <EditDonationComponent
                ref="editDonationComponent"
                changeURL={this.options.changeURL}
                onChange={() => this.redraw()}
            />,
            <MerchantButton
                ref="button"
                label={Flow.donation.getEditDonationComponentButtonLabel()}
                disabled={this.isButtonDisabled()}
                onClick={() => this.updateDonation()}
                className={styleSheet.actionButton}
            />,
        ];
    }

    onMount() {
        super.onMount();

        this.redraw(); // We need this first redraw because we have interdependent components
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument()) {
                if (!iFrameUserDataService.getActiveRecurringDonation()) {
                    Router.changeURL(INLINE_DONATION_URLS.donate);
                } else {
                    this.redraw();
                }
            }
        });
    }
}
